import { StarIconComponent } from 'components/svgIcons/Star';
import React from 'react';


export function PointsComponent({
    TagName = 'span',
    className = '',
    score = 0,
    scoreLabel = (
        <span className='pointing-label'>{score}</span>
    )
}) {

    return (
        <TagName className={`game-score points ${className}`} aria-label="Pontuação">
            <StarIconComponent />
            {scoreLabel}
        </TagName>
    );
};